<div class="bg-m0 flex select-none flex-col p-9">
  <div
    data-cy="reportSaveAsDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-base font-semibold"
    >Draft {{ fromReportId }}</div
  >

  <div
    data-cy="reportSaveAsDialogTitle"
    class="text-s2 mb-9 mt-5 flex-grow select-none text-left text-2xl font-semibold"
    >Save As
  </div>

  <div
    data-cy="reportSaveAsDialogNewRepCheckbox"
    class="flex h-9 flex-row items-center"
  >
    <div
      class="flex cursor-pointer flex-row items-center"
      (click)="newRepOnClick()"
    >
      <div
        class="border-m600 text-m0 flex h-6 w-6 items-center justify-center rounded-full border-2 focus:outline-none"
        [ngClass]="{
          'bg-m600': saveAs === reportSaveAsEnum.NEW_REPORT
        }"
      >
        <m-check-icon
          *ngIf="saveAs === reportSaveAsEnum.NEW_REPORT"
        ></m-check-icon>
      </div>

      <div class="ml-5 text-base">New Report</div>
    </div>
  </div>

  <div
    data-cy="reportSaveAsDialogExistingRepCheckbox"
    class="mt-5 flex h-9 flex-row items-center"
  >
    <div
      class="flex cursor-pointer flex-row items-center"
      (click)="existingRepOnClick()"
    >
      <div
        class="border-m600 text-m0 flex h-6 w-6 items-center justify-center rounded-full border-2 focus:outline-none"
        [ngClass]="{
          'bg-m600': saveAs === reportSaveAsEnum.REPLACE_EXISTING_REPORT
        }"
      >
        <m-check-icon
          *ngIf="saveAs === reportSaveAsEnum.REPLACE_EXISTING_REPORT"
        ></m-check-icon>
      </div>

      <div class="ml-5 flex flex-shrink-0 text-base"
        >Replace Existing Report</div
      >
    </div>

    <div class="ml-5 flex flex-row items-center">
      <div
        class="relative mx-5 flex h-2 w-9 flex-shrink-0"
        *ngIf="!reports && saveAs === reportSaveAsEnum.REPLACE_EXISTING_REPORT"
      >
        <ngx-spinner
          [ngClass]="{
            invisible: saveAs !== reportSaveAsEnum.REPLACE_EXISTING_REPORT
          }"
          class="invisible"
          [name]="spinnerName"
          color="#0084d1"
          bdColor="#00000000"
          size="default"
          type="ball-clip-rotate"
          [fullScreen]="false"
          [disableAnimation]="true"
          [zIndex]="10"
        >
        </ngx-spinner>
      </div>

      <ng-select
        [fixNgSelectBottom]="reportSaveAsDialogExistingReportSelect"
        #reportSaveAsDialogExistingReportSelect
        data-cy="reportSaveAsDialogExistingReportSelect"
        *ngIf="!!reports && saveAs === reportSaveAsEnum.REPLACE_EXISTING_REPORT"
        class="select-h-10 w-[500px] flex-shrink-0 text-base"
        [items]="reports"
        [clearable]="false"
        [searchable]="true"
        [searchFn]="existingReportSearchFn"
        [(ngModel)]="selectedReportId"
        (change)="selectedReportChange()"
        (keyup.esc)="
          $event.stopImmediatePropagation();
          reportSaveAsDialogExistingReportSelect.blur()
        "
        (keyup.enter)="
          $event.stopImmediatePropagation();
          reportSaveAsDialogExistingReportSelect.blur()
        "
        (keyup.esc)="$event.stopImmediatePropagation()"
        (keyup.enter)="$event.stopImmediatePropagation()"
        appendTo="body"
        bindLabel="title"
        bindValue="reportId"
      >
        <ng-template ng-label-tmp ng-option-tmp let-item="item">
          <div
            class="ml-1 flex flex-row"
            [tpIsEnabled]="item.canEditOrDeleteRep === false"
            tp="Report can be modified by author and project members with ProjectAdmin or FilesEditor role. Try to save report as new to become an author."
          >
            <div class="flex truncate">
              <div class="truncate">
                {{ item.title || item.reportId }}
              </div>
            </div>
            <div class="flex flex-grow"></div>
            <div class="ml-5 mr-5 flex flex-shrink-0 font-semibold">{{
              item.author
            }}</div>
          </div>
        </ng-template>
      </ng-select>
    </div>
  </div>

  <div class="text-s400 mt-9 h-7 text-base">
    <div *ngIf="saveAs === reportSaveAsEnum.NEW_REPORT">{{
      newReportPath
    }}</div>

    <div
      *ngIf="
        saveAs === reportSaveAsEnum.REPLACE_EXISTING_REPORT &&
        !!selectedReportId
      "
      >{{ selectedRepPath }}</div
    >

    <div
      *ngIf="
        saveAs === reportSaveAsEnum.REPLACE_EXISTING_REPORT && !selectedReportId
      "
    ></div>
  </div>

  <div class="mt-9 flex flex-row items-start">
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
        >Title</div
      >
    </div>

    <div [formGroup]="titleForm" class="ml-5 flex flex-col items-start">
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="reportSaveAsDialogTitleInput"
        class="form-input border-s3 focus:border-m600 h-10 w-96 rounded"
        [ngClass]="{
          'border-r600':
            titleForm.controls['title'].invalid &&
            titleForm.controls['title'].touched
        }"
        formControlName="title"
      />
      <m-validation [control]="titleForm.controls['title']"></m-validation>
    </div>
  </div>

  <div class="mt-2 flex flex-row items-start">
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
        >Space</div
      >
    </div>

    <div
      class="ml-5 flex flex-col items-start"
      tp="Admin or Editor role required"
      [tpIsEnabled]="canSpecifyReportSpace === false"
    >
      <ng-select
        #reportSaveAsDialogSpaceSelect
        [fixNgSelectBottom]="reportSaveAsDialogSpaceSelect"
        data-cy="reportSaveAsDialogSpaceSelect"
        class="select-h-10 w-96 flex-shrink-0"
        [ngClass]="{
          'pointer-events-none': canSpecifyReportSpace === false
        }"
        [class.report-space-select-disabled]="canSpecifyReportSpace === false"
        [items]="spacesPlusEmpty"
        [multiple]="false"
        [searchable]="true"
        [clearable]="false"
        [disabled]="canSpecifyReportSpace === false"
        [(ngModel)]="selectedSpace"
        (change)="spaceChange()"
        (keyup.esc)="
          $event.stopImmediatePropagation();
          reportSaveAsDialogSpaceSelect.blur()
        "
        (keyup.enter)="
          $event.stopImmediatePropagation();
          reportSaveAsDialogSpaceSelect.blur()
        "
        appendTo="body"
        bindLabel="label"
        bindValue="space"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="ml-1 truncate text-base">{{
            item.space === emptySpaceName ? '' : item.label
          }}</div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div class="ml-1 truncate text-base">{{ item.label }}</div>
        </ng-template>
      </ng-select>
    </div>
  </div>

  <div class="mt-8 flex min-h-[100px] flex-row items-start">
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
        >Access Roles</div
      >
    </div>

    <div class="ml-5 flex flex-col items-start">
      <div [tp]="templateAddAccessRole" [tpIsEnabled]="roles.length === 0">
        <ng-template #templateAddAccessRole>
          <div>Project has no roles</div>
        </ng-template>

        <ng-select
          #reportSaveAsDialogRoleSelect
          [fixNgSelectBottom]="reportSaveAsDialogRoleSelect"
          data-cy="reportSaveAsDialogRoleSelect"
          class="select-h-10 w-96 flex-shrink-0"
          [items]="roles"
          [multiple]="true"
          [searchable]="true"
          [clearable]="true"
          [(ngModel)]="selectedAccessRoles"
          (change)="accessRolesChange()"
          (keyup.esc)="
            $event.stopImmediatePropagation();
            reportSaveAsDialogRoleSelect.blur()
          "
          (keyup.enter)="
            $event.stopImmediatePropagation();
            reportSaveAsDialogRoleSelect.blur()
          "
          appendTo="body"
          bindLabel="roleId"
          bindValue="roleId"
        >
          <ng-template ng-label-tmp let-item="item">
            <div
              class="truncate rounded bg-green-200 px-2 text-base text-green-700"
              >{{ item.roleId }}</div
            >
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            <div class="ml-1 truncate text-base">{{ item.roleId }}</div>
          </ng-template>
        </ng-select>

        <div class="ml-[14px] mt-2 flex w-96 flex-wrap gap-2 text-base">
          <span
            *ngFor="let accessRole of combinedAccessRoles"
            class="truncate rounded px-2"
            [ngClass]="{
              'bg-green-200 text-green-700': accessRole.isDirect,
              'bg-slate-200 text-slate-700': !accessRole.isDirect
            }"
          >
            {{ accessRole.role }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-9">
    <button
      data-cy="reportSaveAsDialogCreateButton"
      class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
      type="button"
      [ngClass]="{
        'bg-m600': saveAs === reportSaveAsEnum.NEW_REPORT || !!selectedReportId,
        'bg-s400 cursor-default':
          saveAs === reportSaveAsEnum.REPLACE_EXISTING_REPORT &&
          selectedReportId === undefined
      }"
      (click)="save()"
      [disabled]="
        saveAs === reportSaveAsEnum.REPLACE_EXISTING_REPORT &&
        selectedReportId === undefined
      "
      >Save</button
    >

    <button
      data-cy="reportSaveAsDialogCancelButton"
      class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
      type="button"
      (click)="cancel()"
      >Cancel</button
    >
  </div>
</div>
